import moment from "moment";
import { FC } from "react";
import { useReleasePacks } from "./ReleasePacks.hook";
import { ReleasePacksList } from "./ReleasePacksList";
import "./style.css";
import { LoadingIndicator } from "../../components/LoadingIndicator";

export const ReleasePacks: FC = () => {
  const {
    iterations,
    selectedIteration,
    workItems,
    uatCompletedWorkItems,
    prdCompletedWorkItems,
    isLoading,
    onSelectIteration,
  } = useReleasePacks();

  return (
    <>
      {!isLoading ? (
        <>
          <h2 className="iteration-info">
            {selectedIteration && (
              <>
                {selectedIteration?.name} (
                {moment(selectedIteration?.attributes?.startDate).format(
                  "YYYY-MM-DD"
                )}
                <> - </>
                {moment(selectedIteration?.attributes?.finishDate).format(
                  "YYYY-MM-DD"
                )}{" "}
                )
              </>
            )}
          </h2>
          <ReleasePacksList
            iterations={iterations}
            workItems={workItems}
            uatCompletedWorkItems={uatCompletedWorkItems}
            prdCompletedWorkItems={prdCompletedWorkItems}
            selectedIteration={selectedIteration}
            onSelectIteration={(event) => onSelectIteration(event)}
          />
        </>
      ) : (
        <div className="loader-container">
          <LoadingIndicator isLoading={isLoading} size={80} />
        </div>
      )}
    </>
  );
};
